/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsDownloadTransactionsStatement204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsDownloadTransactionsStatement505Schema = z.any();

export const optionsDownloadTransactionsStatementMutationResponseSchema = z.lazy(
  () => optionsDownloadTransactionsStatement204Schema
);
